import {useState, useCallback, memo, useEffect} from 'react';
import { Row, Col,Tooltip } from 'reactstrap';
import AnswerChoices from './AnswerChoices';
import PropTypes from 'prop-types';

// represents a single question
const Question = ({
    product,
    questionObj,
    selectedAnswer,
    isRequired,
    isVisible,
    conditionEvaluations,
    onAnswerGiven,
}) => {
    // Move ALL useState and other hooks to the top
    const [state, setState] = useState([]); 
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [productID, setProductID] = useState("");
    const handleAnswer = useCallback((variable, value) => {
        onAnswerGiven(variable, value);
    }, [onAnswerGiven]);

    const toggleTooltip = useCallback(() => {
        setTooltipOpen(!tooltipOpen);
    }, [tooltipOpen]);

    // Add debug logging
     useEffect(() => {
        console.log("question object", questionObj);
        if(product)
        {
            let newID = product.productId.replace(/[.-]/g, "_") + "_" + questionObj.question.variable
            
            setProductID(newID);
        }
       
    }, [product]);
 
    // Conditional returns come after all hooks
    if (!questionObj || !product) {
        return null;
    }

    const getSelectedChoice = () => {
        let selectedChoiceValue = '';
  
        if (selectedAnswer) {
            selectedChoiceValue = selectedAnswer;
        } else {
            const defaultChoice = questionObj.options.find(
                (option) => option.isDefault
            );
 
            if (defaultChoice) {
                selectedChoiceValue = defaultChoice.optionValue;
            }
        }
        return selectedChoiceValue;
    };
 
    if (!isVisible || !questionObj.options) {
        return null;
    }

    if(productID)
    {
        return (
            <Row
                key={`${productID}`}
                style={{ marginTop: '20px' }}
            >
                <Col md='12' style={{ fontWeight: 'bold' }}>
                    <span className={`${isRequired ? "requiredQ" : ""}`}>
                        {questionObj.question.questionText}
                    </span>
                    {questionObj.question.tooltip && questionObj.question.tooltip.length > 0 && (
                       <>
                           <span id={`p_${productID}`} className='tooltipIcon'> 
                                <i className="info">i</i>
                           </span>
                           <Tooltip
                                placement="right"
                                isOpen={tooltipOpen}
                                target={`p_${productID}`}
                                toggle={toggleTooltip}
                           >
                                {questionObj.question.tooltip}
                           </Tooltip>
                       </>     
                    )}
                </Col>
                <Col md='12'>
                    <AnswerChoices
                        questionObj={questionObj}
                        selectedAnswer={selectedAnswer}
                        onAnswerGiven={handleAnswer}
                        conditionEvaluations={conditionEvaluations}
                        product={product}
                    />
    
                </Col>
            </Row>
        );
    }
    return "";
    
};

Question.propTypes = {
    questionObj: PropTypes.shape({
        options: PropTypes.array,
        question: PropTypes.shape({
            variable: PropTypes.string
        })
    }).isRequired,
    selectedAnswer: PropTypes.string,
    onAnswerGiven: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    isVisible: PropTypes.bool,
    conditionEvaluations: PropTypes.object,
    product: PropTypes.shape({
        productId: PropTypes.string.isRequired
    }).isRequired
};


export default memo(Question);
